import React from 'react'
import {
  Avatar,
} from '@material-ui/core'
import {
  People as PeopleIcon,
  CameraAlt as CameraAltIcon,
} from '@material-ui/icons'

import { formatDate } from '../helpers'
import { USER_TYPE } from '../constant'
import TableAutomation from './TableAutomation'


const CastingAutomation = (props) => {
  return (
    <TableAutomation
      head={[
        '',
        { label: 'Name', sort: 'name' },
        { label: 'Brand', sort: 'brand' },
        { label: 'Email of client', sort: 'email' },
        { label: 'Created at', sort: 'created_at' },
        'Type',
      ]}
      row={item => [
        { display: <Avatar src={item.picture} /> },
        item.name,
        item.brand,
        item.email,
        formatDate(item.created_at),
        { display: item.type && (item.type === USER_TYPE.MODEL ? <PeopleIcon color="primary" /> : <CameraAltIcon color="secondary" />) }
      ]}
      {...props}
    />
  )
}


export default CastingAutomation
